import { toast } from 'react-toastify';

export const apiErrorMessage = error => {
  if (error?.code === 'REPORT_LIMIT') return 'O período excede o limite de registros do relatório. Reduza o intervalo; nenhum dado parcial foi exportado.';
  if (error?.code === 'ROUTE_LIMIT') return 'O período contém mais de 10.000 posições. Reduza o intervalo para exibir o percurso completo.';
  if (error?.graphQLErrors?.some(item => item.message === 'The received email is already in use')) return 'Este e-mail já está em uso.';
  const status = error?.status || (error?.networkError?.statusCode || error?.networkError?.status);
  const code = error?.graphQLErrors?.[0]?.extensions?.code;
  if (status === 401 || code === 'UNAUTHENTICATED') return 'Sua sessão expirou. Entre novamente.';
  if (status === 403 || code === 'FORBIDDEN') return 'Você não tem permissão para esta operação.';
  if (status === 429) return 'Muitas tentativas. Aguarde e tente novamente.';
  if (status === 400 || code === 'BAD_USER_INPUT') return 'Verifique os dados informados e tente novamente.';
  if (status === 409) return 'Este registro já existe ou foi alterado. Atualize a lista.';
  if (status === 404) return 'Registro ou serviço não encontrado. Atualize a página.';
  return 'Não foi possível concluir a operação. Verifique a conexão e tente novamente.';
};
export const reportApiError = error => {
  const message = apiErrorMessage(error);
  toast.error(message, { toastId: message });
};
